import { ProposalDeck } from "./ProposalDeck";

/**
 * Route wrapper for the proposal review deck, mirroring SwipePage's own
 * `.path` convention so CRM.tsx registers it the same way.
 */
export const ProposalsPage = () => (
  <div className="p-2 sm:p-4">
    <ProposalDeck />
  </div>
);

ProposalsPage.path = "/proposals";
